import { Wrench, ArrowRight } from 'lucide-react';

function CareersCTA() {
  return (
    <section className="bg-gradient-to-r from-blue-700 to-cogInk py-14 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-between gap-6">
        <div className="flex items-center gap-4">
          <Wrench className="w-9 h-9 text-cyan-300" />
          <h4 className="text-white text-xl sm:text-2xl lg:text-3xl font-display font-bold">
            Join our team building mission-critical systems
          </h4>
        </div>
        <button className="border border-white text-white font-semibold px-6 py-3 rounded-full inline-flex items-center gap-2 hover:bg-white hover:text-cogInk transition-all duration-300 text-sm sm:text-base">
          <span>View Open Positions</span>
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </section>
  );
}

export default CareersCTA;
